import axiosInstance from 'services/axiosMiddleware';

export async function resetCoachPassword(coachdata) {
  try {
    const response = await axiosInstance.post('admin/resetCoachPassword', coachdata);

    if (response.data.status) {
      return response.data.message;
    } else {
      throw new Error(response.data.message);
    }
  } catch (error) {
    console.error('Error resetting Coach password:', error);
    throw error;
  }
}
